<template>
    <div id="app">
        <alert ref="alert"/>
        <x-nav slot="header" v-if="this.showHeaderAndFooter()"/>
        <router-view></router-view>
        <x-footer slot="footer" v-if="this.showHeaderAndFooter()"/>
    </div>
</template>

<script>
import config from './config'
import PageLink from './custom-components/PageLink.vue'
import UnsubscribedNumbers from './custom-components/UnsubscribedNumbers.vue'
import HeaderTotals from './custom-components/HeaderTotals.vue'
import XFooter from './custom-components/Footer.vue';
import XNav from './custom-components/Nav.vue';
import Alert from './custom-components/Alert.vue';

export default {
    name: 'App',
    data () {
        return {
            example: '',
            driverActionPage: false,
            displayHeaderAndFooter: true
        }
    },
    components: {
        'x-footer': XFooter,
        'x-nav': XNav,
        'page-link': PageLink,
        'unsubscribed-numbers': UnsubscribedNumbers,
        'header-tools': HeaderTotals,
        'alert': Alert
    },
    created () {
        this.$eventHub.$on('refreshAll', this.refreshAll);
        this.$eventHub.$on('refreshTrips', this.refreshTrips);
        this.$eventHub.$on('updateTrip', this.updateTrip);
        this.$eventHub.$on('createTrip', this.createTrip);
        /*this.$eventHub.$on('deleteTrip', this.deleteTrip);
        this.$eventHub.$on('restoreTrip', this.restoreTrip);*/
        this.$eventHub.$on('getTripVehicle', this.getVehicleWithPrimaryImage);
        this.$eventHub.$on('createTripNote', this.createTripNote);
        this.$eventHub.$on('deleteTripNote', this.deleteTripNote);
        this.$eventHub.$on('createTripTicket', this.createTripTicket);
      
        this.$socket.on('trips', () => this.refreshTrips())
      
        if(this.$privateReactiveStore.isUserAuthenticated()) {
            console.log("APP CREATED REFRESH ALL");
            this.refreshAll();
        }
    },
    destroyed() {
        this.$eventHub.$off('refreshAll');
        this.$eventHub.$off('refreshTrips');
        this.$eventHub.$off('updateTrip');
        this.$eventHub.$off('createTrip');
        this.$eventHub.$off('getTripVehicle');
        this.$eventHub.$off('createTripNote');
        this.$eventHub.$off('deleteTripNote');
        this.$eventHub.$off('createTripTicket');
    },
    updated() {
        if(this.$privateReactiveStore.isUserAuthenticated() && this.$privateReactiveStore.getFromLogin()) {
            console.log("APP HAS BEEN UPDATED AND THE USER JUST LOGGED IN REFRESH ALL");
            this.refreshAll();
        }
    },
    computed: {
        currentPage() {
          console.log("CURRENT PAGE COMPUTING");
            return this.$router.currentRoute.name;
        }
    },
    methods: {
        showHeaderAndFooter() {
            return (this.$router.currentRoute.name != 'DriverTripStatusPage' && this.$router.currentRoute.name != 'login');
        },
        commitTripPost(dataURL, data) {
            //check if user credentials exist
            if(this.$privateReactiveStore.isUserAuthenticated()) {
                config.stockbookApi(localStorage.getItem('authToken')).post(dataURL, data)
                .then(result => {
                    if(dataURL != '/trips/ticket') {
                      console.log("COMMIT TRIP POST EMITING TRIP UPDATE TO SOCKET");
                        this.$socket.emit('trips');
                    }
                })
                .catch(error => {
                    if(error.response.status == 401) {
                        this.$router.push({ name: 'login', query: { redirect: dataURL } });
                    }
                });
            }
            else {
                this.$router.push({ name: 'login', query: { redirect: dataURL } });
            }
        },
        commitTripGet(dataURL, successCallback) {
            // check if user credentials exist
            if(this.$privateReactiveStore.isUserAuthenticated()) {
                config.stockbookApi(localStorage.getItem('authToken')).get(dataURL)
                .then(result => {
                    successCallback(result);
                })
                .catch(error => {
                    if(error.response.status == 401) {
                        this.$router.push({ name: 'login', query: { redirect: dataURL } });
                    }
                });
            }
            else {
                this.$router.push({ name: 'login', query: { redirect: dataURL } });
            }
        },
        createTrip (data) {
             if(this.$privateReactiveStore.isUserAuthenticated()) {
                config.stockbookApi(localStorage.getItem('authToken')).post('/trips/create', data)
                .then(result => {
                    this.$router.push({ name: 'TripsPage' });
                    this.$socket.emit('trips');
                })
                .catch(error => {
                    if(error.response.status == 401) {
                        this.$router.push({ name: 'login', query: { redirect: dataURL } });
                    }
                    else if(error.response.status == 400) {
                        this.$eventHub.$emit('createTripErrors', error.response.data)
                    }
                });
            }
            else {
                this.$router.push({ name: 'login', query: { redirect: dataURL } });
            }
        },
        updateTrip(id, keyValuePairs) {
            if(Object.keys(keyValuePairs).includes('transit_delays_resolved')) {
                let tripToUpdate = this.$privateReactiveStore.getTrip(id);
                let tripDelaysResolved = tripToUpdate.transit_delays_resolved ? tripToUpdate.transit_delays_resolved.split(',') : [];
                let delayFound = tripDelaysResolved.indexOf(keyValuePairs['transit_delays_resolved']);

                if(delayFound > 0) {
                    tripDelaysResolved.splice(delayFound, 1);
                }
                else {
                  tripDelaysResolved.push(keyValuePairs['transit_delays_resolved'])
                }

                keyValuePairs['transit_delays_resolved'] = tripDelaysResolved.join(','); 
            }
            
            this.$privateReactiveStore.updateTrip(id, keyValuePairs);
            this.commitTripPost('/trips/update/' + id, keyValuePairs);
        },
        /*deleteTrip (data) {
          this.commitTripPost('/trips/destroy/' + data.id, data);
        },
        restoreTrip (data) {
            this.commitTripPost('/trips/restore/' + data.id, data);
        },*/
        createTripNote (data) {
            this.commitTripPost('/tripnotes/create', data);
        },
        deleteTripNote (data) {
            console.log("DELETE NOTE " + data.id);
            this.commitTripPost('/tripnotes/delete/' + data.id);
        },
        createTripTicket (data) {
            if(this.$privateReactiveStore.isUserAuthenticated()) {
                config.stockbookApi(localStorage.getItem('authToken')).post('/trips/ticket', data)
                .then(result => {
                    var url = config.config.stockbookUrl + '/pdf/tripticket/TripTicket' + data.id + '.pdf';
                    console.log("CREATE TRIP TICKET " + url);
            
                    window.open(url, '_blank');
                })
                .catch(error => {
                    if(error.response.status == 401) {
                        this.$router.push({ name: 'login', query: { redirect: dataURL } });
                    }
                });
            }
            else {
                this.$router.push({ name: 'login', query: { redirect: dataURL } });
            }
        },
        searchVehicleResults(partial_stock_number) {

        },
        getVehicleWithPrimaryImage(stock_number) {
            config.stockbookApi(localStorage.getItem('authToken')).get('/vehicleWithPrimaryImage/' + stock_number)
            .then(result => {
                this.$eventHub.$emit('vehicleWithPrimaryImage', result.data.vehicle);
            })
        },
        refreshAll() {
            this.refreshTrips();
            this.refreshLocations();
            this.refreshManagers();
            this.refreshProductSpecialists();
            this.refreshDrivers();
            this.refreshDelays();
        },
        refreshTrips() {
            config.stockbookApi(localStorage.getItem('authToken')).get('/trips')
            .then(result => {
                this.$privateReactiveStore.setTrips(result.data.data);
            })
        },
        refreshDrivers() {
            config.stockbookApi(localStorage.getItem('authToken')).get('/drivers')
            .then(result => {
                let arr = result.data
                arr.sort((a, b) => {
                    if (a.role === 'driver' && b.role !== 'driver') {
                        return -1;
                    }
                    else if (b.role === 'driver' && a.role !== 'driver') {
                        return 1;
                    }
                    else {
                        return a.first_name.localeCompare(b.first_name);
                    }
                });
              
                this.$privateReactiveStore.setDrivers(arr);
            });
        },
        refreshLocations() {
            this.commitTripGet('/facilities', (result) => { 
                this.$privateReactiveStore.setLocations(result.data.data);
            });
        },
        refreshManagers() {
            config.stockbookApi(localStorage.getItem('authToken')).get('/mgrs')
            .then(result => {
                this.$privateReactiveStore.setManagers(result.data.data);
            });
        },
        refreshProductSpecialists() {
            config.stockbookApi(localStorage.getItem('authToken')).get('/product_specialists')
            .then(result => {
                this.$privateReactiveStore.setProductSpecialists(result.data.data);
            });
        },
        refreshUser() {
            config.stockbookApi(localStorage.getItem('authToken')).get('/user/' + this.$privateReactiveStore.getUser().id)
            .then(result => {
                this.$privateReactiveStore.setUser(result.data);
            });
        },
        refreshDelays() {
            config.stockbookApi(localStorage.getItem('authToken')).get('/trip_delays')
            .then(result => {
                this.$privateReactiveStore.setDelays(result.data);
            });
        }
    }
}
</script>

<style lang="less">
    html,
    body {
      margin: 0;
      padding: 0;
      border: 0;
      width: 100%;
      height: 100%;
      -webkit-overflow-scrolling: touch;
      font-family: "myriad-pro", arial, sans-serif;
      font-size: 1em;
    }
    a {
      text-decoration: none;
      cursor: pointer;
    }

    .tooltip {
      display: block !important;
      z-index: 10000;

      .tooltip-inner {
        background: blue;
        color: white;
        border-radius: 16px;
        padding: 5px 10px 4px;
      }

      .tooltip-arrow {
        width: 0;
        height: 0;
        border-style: solid;
        position: absolute;
        margin: 5px;
        border-color: black;
        z-index: 1;
      }

      &[x-placement^="top"] {
        margin-bottom: 5px;

        .tooltip-arrow {
          border-width: 5px 5px 0 5px;
          border-left-color: transparent !important;
          border-right-color: transparent !important;
          border-bottom-color: transparent !important;
          bottom: -5px;
          left: calc(50% - 5px);
          margin-top: 0;
          margin-bottom: 0;
        }
      }

      &[x-placement^="bottom"] {
        margin-top: 5px;

        .tooltip-arrow {
          border-width: 0 5px 5px 5px;
          border-left-color: transparent !important;
          border-right-color: transparent !important;
          border-top-color: transparent !important;
          top: -5px;
          left: calc(50% - 5px);
          margin-top: 0;
          margin-bottom: 0;
        }
      }

      &[x-placement^="right"] {
        margin-left: 5px;

        .tooltip-arrow {
          border-width: 5px 5px 5px 0;
          border-left-color: transparent !important;
          border-top-color: transparent !important;
          border-bottom-color: transparent !important;
          left: -5px;
          top: calc(50% - 5px);
          margin-left: 0;
          margin-right: 0;
        }
      }

      &[x-placement^="left"] {
        margin-right: 5px;

        .tooltip-arrow {
          border-width: 5px 0 5px 5px;
          border-top-color: transparent !important;
          border-right-color: transparent !important;
          border-bottom-color: transparent !important;
          right: -5px;
          top: calc(50% - 5px);
          margin-left: 0;
          margin-right: 0;
        }
      }

      &[aria-hidden='true'] {
        visibility: hidden;
        opacity: 0;
        transition: opacity .15s, visibility .15s;
      }

      &[aria-hidden='false'] {
        visibility: visible;
        opacity: 1;
        transition: opacity .15s;
      }
    }
</style>